import * as PIXI from 'pixi.js';
import { GameAssets } from 'src/shared/util/GameAssets';

export class TextTitlePair extends PIXI.Container {
    private title: PIXI.Text;
    private text: PIXI.Text;
    private sprite: PIXI.Sprite;
    private spacing: number;
    private isLandscape: boolean = true;

    constructor(title: string, text: string, fontSize: number, spacing: number = 50) {
        super();

        this.spacing = spacing;

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["amountBackground.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);

        this.addChild(this.sprite);
        // Initialize title
        this.title = new PIXI.Text({
            text: title,
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: fontSize,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2,
                }
            }
        });
        this.addChild(this.title);

        // Initialize text
        this.text = new PIXI.Text({
            text,
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: fontSize,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2,
                }
            }
        });
        this.addChild(this.text);

        // Initial alignment
        this.updateTextPosition();
    }

    private updateTextPosition(): void {
        if (this.isLandscape) {
            this.title.position.set(-this.sprite.width / 2 - this.title.width - this.spacing, -this.title.height / 2);
            this.text.position.set(-this.text.width / 2, this.text.y = -this.text.height / 2);
        } else {
            this.title.position.set(- this.title.width / 2, -this.sprite.height - this.title.height / 2);
            this.text.position.set(-this.text.width / 2, this.text.y = -this.text.height / 2);
        }
    }

    public onPortrait(): void {
        this.isLandscape = false;
        this.updateTextPosition(); // Recalculate position
    }

    public onLandscape(): void {
        this.isLandscape = true;
        this.updateTextPosition(); // Recalculate position
    }

    public setTitle(newTitle: string): void {
        this.title.text = newTitle;
        this.updateTextPosition(); // Recalculate position
    }

    public setText(newText: string): void {
        this.text.text = newText;
        this.updateTextPosition(); // Ensure position remains consistent
    }

    public setFontSize(newFontSize: number): void {
        this.title.style.fontSize = newFontSize;
        this.text.style.fontSize = newFontSize;
        this.updateTextPosition(); // Adjust position based on new size
    }

    public setSpacing(newSpacing: number): void {
        this.spacing = newSpacing;
        this.updateTextPosition(); // Adjust position based on new spacing
    }
}
